<template>
  <div class="com-league-card" @click="openLeague">
    <OutOpen
      :protocol="heyboxProtocol"
      :page-identifier="'bbs/link'"
      v-if="canUseDeepLink && articleInfo.source == 'share'"
    ></OutOpen>
    <template v-if="!is_loading">
      <div class="static-color-league-img-box">
        <img v-hb-img.src="card_data.icon" alt="" class="league-img" />
        <p class="league-state" :class="leagueState">
          {{ card_data.league_stage }}
        </p>
      </div>
      <div class="league-info-box">
        <div class="line-1">
          <!-- <p class="league-tag">T1</p> -->
          <p class="league-title">{{ card_data.name }}</p>
        </div>
        <div class="line-2">
          <span class="league-date">最近比赛:{{ time }}</span>
          <div class="price-pool" v-if="card_data.prize_pool">
            <hb-icon bbs-money />
            <span class="price" :class="{ suffix: show_price_suffix }">{{
              price
            }}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { timeHandler } from '../../../assets/js/utils';
import { CptMixin } from '../../../mixins/CptMixin';
import { executeProtocol, executeProtocolOutApp } from '_lib/utils';
import OutOpen from '_com/OutOpen';
export default {
  mixins: [CptMixin],
  props: {
    canUseDeepLink: {
      type: Boolean,
    },
  },
  data() {
    return {
      card_data: {},
      time: '',
      price: '',
      show_price_suffix: false,
      is_loading: true,
    };
  },
  components: {
    OutOpen,
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const {
        data: {
          result: { leagues },
          status,
        },
      } = await this.dataInfo.request;
      if (status != 'ok') {
        return;
      }
      this.card_data = leagues?.[0]?.leagues?.find(
        (_) => _.id == this.dataInfo.id,
      );
      if (!this.card_data) return;
      this.time =
        this.card_data.latest_match_time ||
        timeHandler(this.card_data.end_time);
      if (Number(this.card_data.prize_pool) > 10000) {
        this.price =
          (Number(this.card_data.prize_pool) / 10000).toFixed(1) + '万';
        this.show_price_suffix = true;
      } else {
        this.price = Number(this.card_data.prize_pool);
      }
      this.is_loading = false;
      // console.log('[league_request]', this.card_data);
    },
    openLeague() {
      switch (this.articleInfo.source) {
        case 'share': {
          executeProtocolOutApp(this.heyboxProtocol);
          break;
        }
        case 'post': {
          executeProtocol(this.heyboxProtocol);
          break;
        }
      }
    },
  },
  computed: {
    leagueState() {
      let now = new Date().getTime() / 1000;
      return this.card_data.start_time > now
        ? 'wait'
        : this.card_data.start_time < now && this.card_data.end_time > now
          ? 'ing'
          : 'end';
    },
    heyboxProtocol() {
      let url = `${window.$WEB_HOST}/tools/match_center/league_detail?league_id=${this.card_data.id}`;
      let protocol = {
        protocol_type: 'openWindow',
        full_screen: true,
        show_loading: '1',
        status_bar: {
          style: 'light',
        },
        navigation_bar: {
          title: '',
          right_icon: {
            enabled: true,
            protocol: {
              protocol_type: 'share',
              title: this.card_data.name,
              desc: '更多赛事信息，尽在小黑盒！',
              share_url: url + '&is_share=1',
            },
          },
        },
        webview: {
          url: url,
          pull: false,
          refresh: false,
        },
      };
      return 'heybox://' + encodeURIComponent(JSON.stringify(protocol));
    },
  },
};
</script>

<style lang="less">
.com-league-card {
  position: relative;
  display: flex;
  align-items: center;
  height: 80px;
  margin-top: 12px;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(250, 251, 252, 1);
  &::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border-radius: 16px;
    border: 1px solid rgba(243, 244, 245, 1);
    transform: scale(0.5);
    transform-origin: left top;
    pointer-events: none;
  }
  .static-color-league-img-box {
    position: relative;
    width: 128px;
    height: 64px;
    .league-img {
      width: inherit;
      height: inherit;
      object-fit: cover;
      border-radius: 5px;
    }
    .league-state {
      position: absolute;
      top: 0;
      left: 0;
      padding: 6px 10px;
      font-size: 16px;
      line-height: 20px;
      color: #fff;
      border-radius: 10px 4px 4px 4px;
      background: rgba(20, 25, 30, 0.42);
      transform: scale(0.5);
      transform-origin: left top;
      &.ing {
        display: flex;
        align-items: center;
        background: rgba(50, 184, 70, 1);
        &::before {
          content: '';
          display: block;
          width: 6px;
          height: 6px;
          margin-right: 6px;
          border-radius: 50%;
          background: #fff;
        }
      }
    }
  }
  .league-info-box {
    flex: 1;
    width: 0;
    margin-left: 10px;
    .line-1 {
      display: flex;
      align-items: center;
      .league-tag {
        width: 16px;
        font-size: 10px;
        line-height: 16px;
        border-radius: 2px;
        color: #fff;
        text-align: center;
        background: linear-gradient(45deg, #ff6771 0%, #f53e59 100%);
        font-family: PingFang SC;
      }
      .league-title {
        margin-left: 4px;
        font-size: 14px;
        font-weight: 500;
        color: #14191e;
        font-family: PingFang SC;
      }
    }
    .line-2 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      .league-date {
        height: 16px;
        padding: 0 4px;
        border: 1px;
        font-size: 10px;
        color: #64696e;
        line-height: 16px;
        font-family: PingFang SC;
        background: #f3f4f5;
      }
      .price-pool {
        height: 16px;
        padding: 0 4px;
        border: 1px;
        font-size: 12px;
        background: #f3f4f5;
        i {
          font-size: 11px;
          margin-right: 2px;
        }
      }
    }
  }
}
</style>
